import m from "../../geodata/es2015/ukraineHigh";
window.am4geodata_ukraineHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ukraineHigh.js
// module id = null
// module chunks = 